export const APIs = [
  {
    app: "backEnd",
    url: process.env.REACT_APP_BACKEND
  }
];

export default APIs;
